var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"danger","size":"sm","disabled":_vm.isProcessing},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"name":"window-close"}}),_vm._v(" Close ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }